import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useConvenioDetailsDispatch } from './convenio-details-context';
import { ACTION_TYPES } from './convenio-details-reducer';

export const useConvenioDetailsController = () => {
  const dispatch = useConvenioDetailsDispatch();

  const loadConvenioDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getConvenio(id);

      dispatch({ type: ACTION_TYPES.setConvenioDetails, payload: response });
    } catch (error) {
      console.error('Error loading convenio details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes do convênio' });
      dispatch({ type: ACTION_TYPES.setConvenioDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearConvenioDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setConvenioDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportConvenioDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportConvenioDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadConvenioDetails,
    clearConvenioDetails,
    exportConvenioDetail,
  };
};
